import { em } from 'polished'
import styled, { css } from 'styled-components'

import { Text } from 'styles/components/typography'

export const Border = styled.div``

export const TextStyled = styled(Text)`
  margin-bottom: 0;
`

export const Wrapper = styled.div`
  position: relative;
  user-select: none;
  color: ${p => (p.colorTheme === 'dark' ? p.theme.colors.white : null)};

  ${TextStyled}, ${Border}:before {
    ${({
      theme: {
        animation: { timeBtns, cubicBezier, linkTransition },
      },
    }) => css`
      transition: transform ${timeBtns} ${cubicBezier}, ${linkTransition};
    `}
  }

  ${({ isActive }) =>
    isActive &&
    css`
      cursor: default;

      ${TextStyled} {
        transform: translateX(${em(30)});
      }

      ${Border} {
        &:before {
          transform: translateX(${em(30)});
        }
      }
    `}

  ${({ isActive }) =>
    !isActive &&
    css`
      cursor: pointer;

      ${TextStyled} {
        opacity: 0.4;
      }
      ${TextStyled}:hover, ${TextStyled}:hover + ${Border}:before {
        transform: translateX(${em(30)});
      }
      ${TextStyled}:hover {
        opacity: 1;
      }
      ${Border}:before {
        opacity: 0.5;
      }
      ${TextStyled}:hover + ${Border}:before {
        opacity: 1;
      }
    `}

  ${Border} {
    position: relative;
    overflow: hidden;
    &:before {
      content: '';
      display: block;
      border-bottom: 1px solid
        ${p =>
          p.colorTheme === 'dark'
            ? p.theme.colors.whiteOp2
            : p.theme.colors.blackOp07};
    }
  }
`
